import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import {
	LOCATION_MODES,
	type LocationMode,
} from "@/types/admin-portal/routing-mode";

/** The optional reason every write sends; the backend stores it with the history row. */
export function ReasonField({
	id,
	value,
	onChange,
}: {
	id: string;
	value: string;
	onChange: (value: string) => void;
}) {
	const { t } = useTranslation("routing-mode");

	return (
		<div className="flex flex-col gap-2">
			<Label htmlFor={id}>{t("reason.label")}</Label>
			<Textarea
				className="bg-input shadow-inner field-sizing-content min-h-16 max-h-40 resize-none"
				id={id}
				value={value}
				maxLength={1000}
				placeholder={t("reason.placeholder")}
				onChange={(e) => onChange(e.target.value)}
			/>
		</div>
	);
}

export function LocationModeSelect({
	value,
	onChange,
}: {
	value: LocationMode;
	onChange: (value: LocationMode) => void;
}) {
	return (
		<Select value={value} onValueChange={(v) => onChange(v as LocationMode)}>
			<SelectTrigger className="bg-input shadow-inner">
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				{LOCATION_MODES.map((m) => (
					<SelectItem key={m} value={m}>
						{m}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
